import React from "react";
import { renderContent } from "../../utilities/renderContent";
import CtaButton from "../elements/CtaButton";

export default function Testimonial({
  activeTestimonial,
  updateActiveTestimonial,
  hasMultipleTestimonials,
}) {
  return (
    <>
      <div className="absolute z-10 h-full w-full hds-transition transform fade-item fade-up delay-500 duration-1000 is-showing"></div>
      <div className="w-5/6 md:w-1/2 md:absolute top-0 bottom-6 overflow-hidden rounded-br-full rounded-tr-full hds-transition transform md:scale-110 z-10 fade-item fade-left is-showing md:top-6">
        <img
          className="w-full h-full object-cover object-center"
          src={
            activeTestimonial.featuredImage.gatsbyImageData.images.fallback
              ? activeTestimonial.featuredImage.gatsbyImageData.images.fallback
                  .src
              : activeTestimonial.featuredImage.gatsbyImageData.images
                  .sources[0].srcSet
          }
          alt={
            activeTestimonial.featuredImage.alt
              ? activeTestimonial.featuredImage.alt
              : ""
          }
        />
      </div>
      <div className="hds-section overflow-visible z-10">
        <div className="md:w-1/2 md:ml-1/2 md:pl-32 hds-transition fade-item delay-200 fade-left is-showing">
          {hasMultipleTestimonials && (
            <div className="hidden md:flex">
              <img
                className="cursor-pointer mr-4"
                src="https://firebasestorage.googleapis.com/v0/b/testing-e5559.appspot.com/o/Group_143.svg-(10-1.586)?alt=media&amp;token=2fcb3bd7-45cf-4652-8dfd-e6c783aa35a9"
                alt=""
                onClick={() => updateActiveTestimonial(false)}
              />
              <img
                className="cursor-pointer"
                src="https://firebasestorage.googleapis.com/v0/b/testing-e5559.appspot.com/o/Frame_93.svg-(10-1.583)?alt=media&amp;token=dd10b8e6-9986-407c-bcf2-1cd133c7d574"
                alt=""
                onClick={() => updateActiveTestimonial(true)}
              />
            </div>
          )}
          <div className="pt-5 mb-1">
            {activeTestimonial.testimonialLogo && (
              <img
                className="h-full object-scale-down object-center testimonial-logo"
                src={
                  activeTestimonial.testimonialLogo.gatsbyImageData.images
                    .fallback
                    ? activeTestimonial.testimonialLogo.gatsbyImageData.images
                        .fallback.src
                    : activeTestimonial.testimonialLogo.gatsbyImageData.images
                        .sources[0].srcSet
                }
                alt={
                  activeTestimonial.testimonialLogo.alt
                    ? activeTestimonial.testimonialLogo.alt
                    : ""
                }
              />
            )}
          </div>
          <h4 className="hds-title-color mb-12 font-black leading-none text-2xl uppercase pt-5 bold-color font-heading">
            {activeTestimonial.heading}
          </h4>
          <div
            dangerouslySetInnerHTML={renderContent(activeTestimonial.copy)}
          />
          {activeTestimonial.callToActionButtonLink &&
            activeTestimonial.callToActionButtonText && (
              <CtaButton
                link={activeTestimonial.callToActionButtonLink}
                text={activeTestimonial.callToActionButtonText}
              />
            )}
        </div>
      </div>
    </>
  );
}
